module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/live-count.b89e6ddd.svg";